import React from 'react';
import { volumes } from '../data/content';
import { Eyebrow, Mark, SectionTitle } from './ui/Section';
export function Volumes() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-235" data-mp="1lwl5eoi9puq1">
      <div className="mx-auto max-w-3xl" data-id="element-236" data-mp="184ey7rx3ey2q">
        <Eyebrow data-id="element-237" data-mp="185q5i1pqynyl">What's included</Eyebrow>
        <SectionTitle data-id="element-238" data-mp="1c57a6sxcnh2p">
          5 complete volumes. <Mark data-id="element-239" data-mp="1c609j8tzb4at">One organized system.</Mark>
        </SectionTitle>

        <ul className="mt-8 space-y-4" data-id="element-240" data-mp="1zujepfhqf0yo">
          {volumes.map(volume => <li key={volume.number} className="overflow-hidden rounded-2xl border border-navy/10 shadow-sm" data-id="element-241" data-mp="24u5xs5k8rbfe">
              <div className="flex items-center gap-3 bg-brand-light px-4 py-3 md:px-5" data-id="element-242" data-mp="1quweuy4ni37q">
                <span className="shrink-0 rounded-md bg-navy px-2.5 py-1 font-display text-[10px] font-black uppercase tracking-wider text-white md:text-[11px]" data-id="element-243" data-mp="1vt7p39yuyfqh">
                  Volume {Number(volume.number)}
                </span>
                <h3 className="font-display text-sm font-black uppercase leading-tight text-navy md:text-base" data-id="element-244" data-mp="kfc7lukhduw3">
                  {volume.name}
                </h3>
              </div>
              <div className="bg-white px-4 py-4 md:px-5" data-id="element-245" data-mp="3j9vcy2i1ljqw">
                <p className="text-sm leading-relaxed text-steel" data-id="element-246" data-mp="3jbg7hs4cx2or">{volume.text}</p>
                <p className="mt-1.5 text-sm leading-relaxed text-steel" data-id="element-247" data-mp="229r1rdjnpc4">{volume.detail}</p>
                <p className="mt-3 font-display text-[11px] font-black uppercase tracking-wider text-brand" data-id="element-248" data-mp="3t5opvmzobf97">
                  {volume.tagline}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}